export var LookAndFeelFileUnloggedStatus;
(function (LookAndFeelFileUnloggedStatus) {
    LookAndFeelFileUnloggedStatus[LookAndFeelFileUnloggedStatus["LOADING"] = 0] = "LOADING";
    LookAndFeelFileUnloggedStatus[LookAndFeelFileUnloggedStatus["PARSE_READ_ERROR"] = 1] = "PARSE_READ_ERROR";
    LookAndFeelFileUnloggedStatus[LookAndFeelFileUnloggedStatus["READY"] = 2] = "READY";
    LookAndFeelFileUnloggedStatus[LookAndFeelFileUnloggedStatus["NOT_PROVIDED"] = 3] = "NOT_PROVIDED";
})(LookAndFeelFileUnloggedStatus || (LookAndFeelFileUnloggedStatus = {}));
export const createEmptyLookAndFeelUnloggedFrame = () => ({
    cssText: null,
    cssFileStatus: LookAndFeelFileUnloggedStatus.NOT_PROVIDED,
    logoDataUrl: null,
    logoFileStatus: LookAndFeelFileUnloggedStatus.NOT_PROVIDED,
});
